<template>
  <div class="min-h-screen flex flex-col">
    <LayoutNavbar :menu-style="'2'" class="navbar fixed top-0 flex items-center text-white justify-between fixed left-0 top-0 w-full shadow z-50 px-4 py-2 md:px-6 lg:px-8 bg-[linear-gradient(270deg,_#0077BC_0%,_#262772_100%)]"/>
    <!-- Main content goes here -->
    <div class="flex-grow"> 
      <NuxtPage  />
      <!-- page content -->
    </div>
    <!-- Spacer to offset fixed menu height -->
    <footer class="relative fixed bottom-0 left-0 w-full py-6 text-sm text-white" 
      style="border-top: 1px solid #ffffff2b; margin-top:-10px;background: linear-gradient(270deg, #00807e 0, #262772 100%);">
      <div class="flex items-center justify-center gap-2">
        <span>© {{ new Date().getFullYear() }}. {{$t('common.default_layout.footer_company_rights_disclaimer') }}.</span>
      </div>
      <div class="absolute right-6 top-1/2 transform -translate-y-1/2 hidden sm:block text-xs">
        <LanguageSwitcher />
      </div>
    </footer>
  </div>
  <ScrollToTop />
</template>

<script lang="ts" setup>
//console.log("mounted");

import ScrollToTop from '~/components/ScrollToTop/index.vue'
import LogoIcon from '~/assets/3a-logo-core-materials.svg'
</script>

<style>

.layout-enter-active,
.layout-leave-active {
  transition: all 0.4s;
}
.layout-enter-from,
.layout-leave-to {
  filter: grayscale(1);
}
</style>